interface IIsNearEndParams {
  /** contentOffset.y do evento de scroll */
  offsetY: number
  /** layoutMeasurement.height — altura visível do scroller */
  viewportHeight: number
  /** contentSize.height — altura total do conteúdo */
  contentHeight: number
  /** Distância (px) do fim que já conta como "chegou perto". */
  threshold?: number
}

export const DEFAULT_END_REACHED_THRESHOLD = 600

/**
 * Diz se o scroll chegou perto do fim do conteúdo.
 *
 * Usado para paginar por distância em vez de exigir que o usuário encoste no
 * fim: quem arrasta a barra lateral (notebook/trackpad) chega ao fundo, a página
 * seguinte é anexada, o conteúdo cresce e o fim "foge" — sem isso é preciso um
 * arrasto novo para cada página.
 */
export function isNearEnd({
  offsetY,
  viewportHeight,
  contentHeight,
  threshold = DEFAULT_END_REACHED_THRESHOLD,
}: IIsNearEndParams) {
  if (contentHeight <= 0 || viewportHeight <= 0) return false
  const distanceToEnd = contentHeight - (offsetY + viewportHeight)
  return distanceToEnd <= threshold
}
